import BreadCrumbs from '../components/breadCrumbs'

import { useEffect, useState } from 'react'
import AnimatedPage from '../components/animatedPage'
import { DecodeHtml } from '../utils/decodeHtml'
import useFetch from '../utils/useFetch'
import FeedbackForm from '../components/contactUs/feedbackForm'
import Accordion from '../components/campusLife/accordion'

const ContactUs = () => {
  const contactUsData = useFetch('contact-us')
  console.log(contactUsData)

  const [accordion, setAccordion] = useState(false)

  useEffect(() => {
    if (contactUsData !== null) {
      setAccordion([
        ...contactUsData.properties.accordions.items.map(item => {
          item = item?.content?.properties
          return {
            question: item?.label,
            answer: DecodeHtml({ html: item?.accordionContent?.markup }),
            open: false
          }
        }),
        {
          question: 'Feedback Form',
          answer: <FeedbackForm />,
          open: false
        }
      ])
    }
  }, [contactUsData])

  const maps = [
    'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d63750.34779830185!2d101.672424!3d2.987262!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cdcbd32f300b1d%3A0xfd29fd7e373dab16!2sUniversiti%20Tenaga%20Nasional%20(UNITEN)!5e0!3m2!1sen!2sus!4v1714297466549!5m2!1sen!2sus',
    'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d31873.141411316283!2d103.083793!3d3.05647!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cf098067e65709%3A0xdf460d9110b647a5!2sUniten%20Sultan%20Haji%20Ahmad%20Shah%20Campus!5e0!3m2!1sen!2sus!4v1746631123164!5m2!1sen!2sus'
  ]

  const addresses = contactUsData?.properties?.campusAddresses?.items?.map(
    (item, i) => {
      item = item?.content?.properties
      return {
        title: item?.title,
        address: DecodeHtml({ html: item?.description?.markup }),
        mapLink: maps[i]
      }
    }
  )

  return (
    <AnimatedPage>
      {/* <ScrollToTop /> */}
      <section className=''>
        <div className="relative min-h-screen  overflow-hidden bg-cover bg-center bg-no-repeat bg-[url('/assets/contact_banner.svg')]">
          <div className='absolute inset-0 bg-[rgba(0,0,0,0.2)]'></div>
          <div className='absolute top-1/2 -translate-y-1/2 gap-3 flex flex-col items-center left-1/2 -translate-x-1/2'>
            <h1 className='text-5xl lg:text-[4rem] whitespace-nowrap font-bold text-white'>
              Contact Us
            </h1>
            <BreadCrumbs />
          </div>
        </div>
      </section>
      <div className='block w-full mx-auto lg:max-w-7xl  px-6 py-10 md:px-8 '>
        {accordion && (
          <Accordion accordion={accordion} setAccordion={setAccordion} />
        )}

        <div className='grid grid-cols-1 md:grid-cols-2 gap-8  py-10 '>
          {addresses?.map((item, i) => (
            <div key={i} className='flex flex-col gap-5 w-full'>
              <h1 className='text-3xl font-bold '>{item?.title}</h1>
              <div className='flex flex-col gap-5'>
                {item?.address}
                <iframe
                  className='lg:max-w-7xl w-full rounded-xl overflow-hidden border shadow'
                  src={item?.mapLink}
                  height='400'
                  style={{ border: 0 }}
                  allowFullScreen=''
                  loading='lazy'
                ></iframe>
              </div>
            </div>
          ))}

          {/* <iframe
          className='lg:max-w-7xl w-full rounded-xl overflow-hidden border shadow'
          src=''
          height='400'
          style={{ border: 0 }}
          allowFullScreen=''
          loading='lazy'
        ></iframe> */}
        </div>
      </div>
    </AnimatedPage>
  )
}

export default ContactUs
